import { Route } from '@angular/router';
import { Routes } from './shared/enums';

export const appRoutes: Route[] = [
    {
        path: Routes.Home,
        loadChildren: () => import('./routes/home/home.routes').then(m => m.homeRoutes)
    },
    {
        path: Routes.Start,
        loadChildren: () => import('./routes/start/start.routes').then(m => m.startRoutes)
    },
    {
        path: Routes.QuestionFlowEditor,
        loadChildren: () => import('./routes/question-flow-editor/question-flow-editor.routes').then(m => m.questionFlowEditorRoutes)
    },
    {
        path: Routes.QuestionFlowTester,
        loadChildren: () => import('./routes/question-flow-tester/question-flow-tester.routes').then(m => m.questionFlowTesterRoutes)
    },
    {
        path: Routes.UIComponents,
        loadChildren: () => import('./routes/ui-components/ui-components.routes').then(m => m.uiComponentsRoutes)
    },
    {
        path: Routes.Pages,
        loadChildren: () => import('./routes/pages/pages.routes').then(m => m.pagesRoutes)
    },
    {
        path: '**',
        redirectTo: Routes.Home
    }
];
